var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showModal && _vm.activeMapping
        ? _c(
            "modal-box",
            {
              attrs: { open: _vm.showModal },
              domProps: {
                onClose: () => (_vm.showModal = false),
                enableHeader: true,
                enableFooter: false,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "line-height": "var(--adam-d48)" },
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("h3", [_vm._v(_vm._s(_vm.activeMapping.assetName))])]
              ),
              _c("kpi-mapping-editor", {
                attrs: { mapping: _vm.activeMapping, kpis: _vm.availableKpis },
                on: {
                  close: function ($event) {
                    return _vm.onModalClose($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("content-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function () {
              return [
                _c("div", { staticClass: "pl-2" }, [
                  _c(
                    "div",
                    { staticClass: "search-filter" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter,
                            expression: "filter",
                          },
                        ],
                        staticClass: "search",
                        attrs: { type: "text", placeholder: _vm.$t("search") },
                        domProps: { value: _vm.filter },
                        on: {
                          keyup: function ($event) {
                            return _vm.updateFilter()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.filter = $event.target.value
                          },
                        },
                      }),
                      _c("font-awesome-icon", {
                        staticClass: "search-icon fa-2x",
                        attrs: { icon: "search" },
                      }),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.filter !== "",
                              expression: "filter !== ''",
                            },
                          ],
                          staticClass: "clear-search",
                          on: {
                            click: function ($event) {
                              return _vm.clearFilter()
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "clear",
                            attrs: { icon: ["fas", "times"] },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _vm.loading
                  ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "mr-2 ml-2" },
                  [
                    _c("div", { staticClass: "alert alert-info" }, [
                      _vm._v(" " + _vm._s(_vm.$t("kpiMappingsInfo")) + " "),
                    ]),
                    _vm._l(_vm.availableMappings, function (mapping) {
                      return _c(
                        "div",
                        {
                          key: mapping.hierarchySid,
                          staticClass: "kpi-mapping mb-1",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex-row pr-1 pl-1 pb-2 pt-2" },
                            [
                              _c("div", { staticClass: "flex-1" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(mapping.hierarchySid) +
                                      " - " +
                                      _vm._s(mapping.assetName)
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chartTypes." + mapping.chartType)
                                    )
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "flex-3" }, [
                                _c(
                                  "ol",
                                  { staticClass: "mt-0" },
                                  _vm._l(mapping.kpis, function (kpi) {
                                    return _c("li", { key: kpi.id }, [
                                      _vm._v(_vm._s(kpi.name)),
                                    ])
                                  }),
                                  0
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: {
                                      disabled: ![
                                        "Unset",
                                        "PerformanceBenchmark",
                                        "SingleKpi",
                                      ].includes(mapping.chartType),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(mapping)
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "edit" },
                                    }),
                                    _vm._v(" " + _vm._s(_vm.$t("edit")) + " "),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }